import { configurationServiceChartTypes } from 'src/services/echartConfiguration/chartTypes';
import AnalyzeService from '../../services/analyze';
import ConfigurationService from '../../services/echartConfiguration';
import sortColorPickerColors from '../../util/colorPicker/sortColorPickerColors';
import { withFulFilled, withPending, withRejected } from '../reducers/commons';
import StatsService from "src/services/stats";

const {
  simpleChart,
  multipleCrossChart,
  evolutiveChart,
  evolutiveCrossChart,
  simpleCrossChart,
  correlationAutoChart,
  correlationManualChart,
} = configurationServiceChartTypes;

const resolveCorrelationChartType = (isAuto) => (
  isAuto ? correlationAutoChart : correlationManualChart
);

const configurationService = new ConfigurationService();

// actions
export const FETCH_SIMPLE_CHART_DATA = 'FETCH_SIMPLE_CHART_DATA';
export const UPDATE_SIMPLE_CHART_COLOR_SCHEME = 'UPDATE_SIMPLE_CHART_COLOR_SCHEME';
export const FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA = 'FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA';
export const UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA = 'UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA';
export const UPDATE_CHART_COLOR_CONFIG_DATA = 'UPDATE_CHART_COLOR_CONFIG_DATA';
export const FETCH_SIMPLE_CROSS_CHART_DATA = 'FETCH_SIMPLE_CROSS_CHART_DATA';

export const FETCH_MULTI_CROSS_CHART_DATA = 'FETCH_MULTI_CROSS_CHART_DATA';
export const FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA = 'FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA';
export const UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA = 'UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA';
export const UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME = 'UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME';
export const UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA = 'UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA';

export const FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA = 'FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA';
export const UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA = 'UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA';
export const UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA = 'UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA';
export const UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME = 'UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME';

/**
 * Evolutivo
 */
export const FETCH_EVOLUTIVE_CHART_DATA = 'FETCH_EVOLUTIVE_CHART_DATA';
export const FETCH_CORRELATION_CHART_DATA = 'FETCH_CORRELATION_CHART_DATA';
export const FETCH_SIMULATION_CHART_DATA = 'FETCH_SIMULATION_CHART_DATA';
export const FETCH_PREDICT_EVOLUTIVE_CHART_DATA = 'FETCH_PREDICT_EVOLUTIVE_CHART_DATA';
export const FETCH_EVOLUTIVE_CHART_CONFIG_DATA = 'FETCH_EVOLUTIVE_CHART_CONFIG_DATA';
export const UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA = 'UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA';
export const UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA = 'UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA';
export const UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME = 'UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME';

/**
 * Evolutivo de Cruzamentos
 */
export const FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA = 'FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA';
export const UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA = 'UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA';
export const UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA = 'UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA';
export const UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME = 'UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME';

export const CALCULATE_SIMULATION_CHART_DATA = 'CALCULATE_SIMULATION_CHART_DATA';
export const RESET_ERROR_SIMULATION_CHART_DATA = 'RESET_ERROR_SIMULATION_CHART_DATA';

/**
 * Correlação (configuração de cores por pergunta)
 */
export const FETCH_CORRELATION_CHART_CONFIG_DATA = 'FETCH_CORRELATION_CHART_CONFIG_DATA';
export const UPDATE_CORRELATION_COLOR_CONFIG_DATA = 'UPDATE_CORRELATION_COLOR_CONFIG_DATA';
export const UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA = 'UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA';
export const UPDATE_CORRELATION_CHART_COLOR_SCHEME = 'UPDATE_CORRELATION_CHART_COLOR_SCHEME';

// action: recupera os dados de configuracao de cor do simple chart
export function fetchSimpleChartColorConfigData(surveyId, questionId, dispatch) {
  const dataPromise = configurationService.fetchConfigData(surveyId, questionId, simpleChart);
  dispatch({ type: FETCH_SIMPLE_CHART_COLOR_CONFIG_DATA, payload: dataPromise });
}

// action: atualiza os dados de configuração de cor do chart na API
// e atualiza o estado do redux das cores do colorpicker (para o usuario ver as cores
// recentemente configuradas nas ultimas chamadas dessa action)
export function updateChartColorConfigData(surveyId, questionId, newData, colorPickerColors, newColor, apiHasNoConfigs = false, dispatch, successCallback) {
  // calcula nova ordem das cores
  const newColorsArray = sortColorPickerColors(colorPickerColors, newColor, simpleChart);
  // Dispara a action a ser tratada no reducer
  dispatch({ type: withPending(UPDATE_CHART_COLOR_CONFIG_DATA) });

  // Caso a api não tenha configuração, será feito um post request para criar as configurações para o gráfico simples
  if (apiHasNoConfigs) {
    configurationService.createConfigData(surveyId, questionId, newData, simpleChart)
      .then((data) => {
        if (typeof successCallback === 'function') {
          successCallback();
        }

        dispatch({ type: withFulFilled(UPDATE_CHART_COLOR_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }});
      })
      .catch((error) => dispatch({ type: withRejected(UPDATE_CHART_COLOR_CONFIG_DATA), payload: error }));
  } else {
    configurationService.updateConfigData(surveyId, questionId, newData, simpleChart)
      .then((data) => {
        if (typeof successCallback === 'function') {
          successCallback();
        }

        dispatch({ type: withFulFilled(UPDATE_CHART_COLOR_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }});
      })
      .catch((error) => dispatch({ type: withRejected(UPDATE_CHART_COLOR_CONFIG_DATA), payload: error }));
  }
}

export function updateSimpleChartColorsObject(surveyId, questionId, newData, apiHasNoConfigs = false, dispatch) {
  // Dispara a action a ser tratada no reducer
  dispatch({ type: withPending(UPDATE_CHART_COLOR_CONFIG_DATA) });

  // Caso a api não tenha configuração, será feito um post request para criar as configurações para o gráfico simples
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, simpleChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_CHART_COLOR_CONFIG_DATA), payload: { data, newData }})
    }).catch((error) => {
      dispatch({ type: withRejected(UPDATE_CHART_COLOR_CONFIG_DATA), payload: error })
    });
}

// Atualiza as configurações de tema do gráfico de cruzamento simples
export function updateSimpleCrossChartColorScheme(surveyId, questionId, newData, selectedOption, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME), payload: {}});
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  const { chartsColors } = newData;

  request(surveyId, questionId, newData, simpleCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME), payload: { data, newChartsColors: chartsColors, newColorScheme: selectedOption }});
    }).catch((error) => {
      dispatch({ type: withRejected(UPDATE_SIMPLE_CROSS_CHART_COLOR_SCHEME), payload: error });
    });
}

// Atualiza as configurações de tema do gráfico evolutivo
export function updateEvolutiveChartColorScheme(surveyId, questionId, newData, selectedOption, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME), payload: {}});
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  const { chartsColors } = newData;

  request(surveyId, questionId, newData, evolutiveChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME), payload: { data, newChartsColors: chartsColors, newColorScheme: selectedOption }});
    }).catch((error) => {
      dispatch({ type: withRejected(UPDATE_EVOLUTIVE_CHART_COLOR_SCHEME), payload: error });
    });
}

// Atualiza as configurações de tema do gráfico de cruzamento múltiplo
export function updateMultipleCrossChartColorScheme(surveyId, questionId, newData, selectedOption, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME), payload: {}});
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  const { chartsColors } = newData;
  request(surveyId, questionId, newData, multipleCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME), payload: { data, newChartsColors: chartsColors, newColorScheme: selectedOption }});
    }).catch((error) => {
      dispatch({ type: withRejected(UPDATE_MULTIPLE_CROSS_CHART_COLOR_SCHEME), payload: error });
    });
}

// Atualiza as configurações de tema do gráfico simples
export function updateSimpleChartColorScheme(
  surveyId,
  questionId,
  newData,
  selectedOption,
  apiHasNoConfigs = false,
  dispatch,
  successCallback,
) {
  dispatch({ type: withPending(UPDATE_SIMPLE_CHART_COLOR_SCHEME), payload: {}});
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  const { chartsColors } = newData;

  request(surveyId, questionId, newData, simpleChart)
    .then((data) => {
      if (typeof successCallback === 'function') {
        successCallback();
      }
      dispatch({ type: withFulFilled(UPDATE_SIMPLE_CHART_COLOR_SCHEME), payload: { data, newChartsColors: chartsColors, newColorScheme: selectedOption }});
    }).catch((error) => {
      dispatch({ type: withRejected(UPDATE_SIMPLE_CHART_COLOR_SCHEME), payload: error });
    });
}

// action: recupera os dados de configuracao de cor do simple cross chart
/**
 * dispara uma action que carrega as configuracoes de um gráfico de cruzamento simples
 *
 * @param {*} surveyId id da pesquisa selecionada
 * @param {*} questionId id da questão selecionada
 * @param {*} themeColorArray array de cores de tema
 */
export function fetchSimpleCrossChartColorConfigData(surveyId, questionId, dispatch) {
  dispatch({ type: withPending(FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA) });
  configurationService.fetchConfigData(surveyId, questionId, simpleCrossChart)
    .then((data) => dispatch({ type: withFulFilled(FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA),
      payload: {
        data,
      },
    }))
    .catch((error) => dispatch({ type: withRejected(FETCH_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA),
      payload: {
        error,
      }}));
}

/**
 * Função que dispara uma action que atualiza os dados da configuracao de cor de um grafico de cruzamento na API
 *
 * @param {*} surveyId id da pesquisa
 * @param {*} questionId id da pergunta
 * @param {*} newData novos dados (a serem submetidos para a API)
 * @param {*} colorPickerColors as cores do colorpicker
 * @param {*} newColor nova cor clicada
 */
export function updateSimpleCrossChartColorConfigData(
  surveyId,
  questionId,
  newData,
  colorPickerColors,
  newColor,
  apiHasNoConfigs = false,
  dispatch,
) {
  // calcula nova ordem das cores
  const newColorsArray = sortColorPickerColors(colorPickerColors, newColor, simpleCrossChart);
  dispatch({ type: withPending(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA) });
  if (apiHasNoConfigs) {
    configurationService.createConfigData(surveyId, questionId, newData, simpleCrossChart)
      .then((data) => dispatch({ type: withFulFilled(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }}))
      .catch((error) => dispatch({ type: withRejected(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA), payload: error }));
  } else {
    configurationService.updateConfigData(surveyId, questionId, newData, simpleCrossChart)
      .then((data) => dispatch({ type: withFulFilled(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }}))
      .catch((error) => dispatch({ type: withRejected(UPDATE_SIMPLE_CROSS_CHART_COLOR_CONFIG_DATA), payload: error }));
  }
}

// Dispara uma action para atualizar a configuração de fontes do gráfico de cruzamento simples
export function updateSimpleCrossChartFontSizeConfigData(surveyId, questionId, newFontsSizes, newData, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA), payload: newFontsSizes });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, simpleCrossChart)
    .then((data) => dispatch({ type: withFulFilled(UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA), payload: { data, newFontsSizes }}))
    .catch((error) => dispatch({ type: withRejected(UPDATE_SIMPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA), payload: error }));
}

export function updateSimpleChartFontSizeConfigData(surveyId, questionId, newFontsSizes, newData, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA), payload: newFontsSizes });

  // Nova síntaxe para abstrair o método da requisição, retorna o método que lida com o POST ou com o PUT.
  const request = configurationService.getRequestMethod(apiHasNoConfigs);
  request(surveyId, questionId, newData, 'simpleChart')
    .then((data) => dispatch({ type: withFulFilled(UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA), payload: { data, newFontsSizes }}))
    .catch((error) => dispatch({ type: withRejected(UPDATE_SIMPLE_CHART_FONTSIZE_CONFIG_DATA), payload: error }));
}

// action: atualiza as configurações de fontes do gráfico de cruzamento múltiplo
export function updateMultipleCrossFontSizeConfigData(surveyId, questionId, newFontsSizes, newData, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA), payload: newFontsSizes });
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, multipleCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA), payload: { data, newFontsSizes }});
    })
    .catch((error) => dispatch({ type: withRejected(UPDATE_MULTIPLE_CROSS_CHART_FONTSIZE_CONFIG_DATA), payload: error }));
}

// action: recupera o resultado geral de uma pesquisa e questão
export function fetchSimpleChartData(surveyId, questionId, clientId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.generalResults(surveyId, questionId, clientId);
  dispatch({ type: FETCH_SIMPLE_CHART_DATA, payload: dataPromise });
}

// action: recupera o resultado do cruzamento simples de uma pesquisa e questão
export function fetchSimpleCrossingChartData(surveyId, questionId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.simpleCrossing(surveyId, questionId);
  dispatch({ type: FETCH_SIMPLE_CROSS_CHART_DATA, payload: dataPromise });
}

// action: recupera o resultado do cruzamento simples de uma pesquisa e questão
export function fetchMultiCrossingChartData(configId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.multiCrossing(configId);
  dispatch({ type: FETCH_MULTI_CROSS_CHART_DATA, payload: dataPromise, meta: { configId }});
}

// action: recupera os dados de configuração de um cruzamento multiplo.
export function fetchMultipleCrossChartColorConfigData(surveyId, analyzeId, dispatch) {
  dispatch({ type: withPending(FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA) });
  configurationService.fetchConfigData(surveyId, analyzeId, multipleCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA), payload: { data }});
    })
    .catch((error) => {
      dispatch({ type: withRejected(FETCH_MULTIPLE_CROSS_CHART_CONFIG_DATA), payload: { error }});
    });
}

/**
 * Dispara action que atualiza o estado de configurações de um cruzamento múltiplo.
 * Se a configuração ainda não existir na API, ele cria a configuração usando o POST, senão, apenas atualiza, usando um PUT
 * @param {*} surveyId Id da pesquisa
 * @param {*} questionId Id da questão
 * @param {*} newData Novos dados de configuração a ser enviado para a API
 * @param {*} colorPickerColors Cores a serem persistidas na memorização do colorpicker
 * @param {*} newColor Nova cor selecionada
 * @param {*} apiHasNoConfigs Estado que verifica se a API tem alguma configuração para este gráfico definida
 */
export function updateMultipleCrossChartColorConfigData(
  surveyId,
  questionId,
  newData,
  colorPickerColors,
  newColor,
  apiHasNoConfigs = false,
  dispatch,
) {
  // calcula nova ordem das cores
  const newColorsArray = sortColorPickerColors(colorPickerColors, newColor, multipleCrossChart);
  dispatch({ type: withPending(UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA) });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, multipleCrossChart)
    .then((data) => dispatch({ type: withFulFilled(UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }}))
    .catch((error) => dispatch({ type: withRejected(UPDATE_MULTIPLE_CROSS_CHART_CONFIG_DATA), payload: error }));
}

// action: recupera o resultado do correlação automática de uma pesquisa e questão
export function fetchAutoCorrelationChartData(customerId, surveyId, questionId, dispatch) {
  const service = new StatsService();
  const dataPromise = service.autoCorr(customerId, surveyId, questionId);
  dispatch({ type: FETCH_CORRELATION_CHART_DATA, payload: dataPromise, meta: { fetchType: 'auto' }});
}

// action: recupera o resultado do correlação manual de uma pesquisa e questão
export function fetchCorrelationChartData(customerId, surveyId, configId, dispatch) {
  const service = new StatsService();
  const dataPromise = service.manualCorr(customerId, surveyId, configId);
  dispatch({ type: FETCH_CORRELATION_CHART_DATA, payload: dataPromise, meta: { fetchType: 'manual' }});
}

// action: recupera os dados iniciais para simular uma pesquisa
export function fetchSimulationChartData(customerId, surveyId, questionId, dispatch) {
  const service = new StatsService();
  const dataPromise = service.simulation(customerId, surveyId, questionId);
  dispatch({ type: FETCH_SIMULATION_CHART_DATA, payload: dataPromise });
}

// action: calcula os dados de predição a partir dos dados do evolutivo
export function fetchPredictEvolutiveChartData(customerId, surveyId, questionId, data, periods, dispatch) {
  const service = new StatsService();
  const dataPromise = service.predict(customerId, surveyId, questionId, data, periods);
  dispatch({ type: FETCH_PREDICT_EVOLUTIVE_CHART_DATA, payload: dataPromise });
}

// action: recupera os dados de configurações do gráfico evolutivo de uma pesquisa e questão
export function fetchEvolutiveChartData(surveyId, questionId, themeColorArray, dispatch) {
  dispatch({ type: withPending(FETCH_EVOLUTIVE_CHART_CONFIG_DATA), payload: { themeColorArray }});

  configurationService.fetchConfigData(surveyId, questionId, evolutiveChart)
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_EVOLUTIVE_CHART_CONFIG_DATA), payload: { data, themeColorArray }});
    })
    .catch((error) => dispatch({ type: withRejected(FETCH_EVOLUTIVE_CHART_CONFIG_DATA), payload: { error, themeColorArray }}));
}

// action: atualizar as configurações de cores do gráfico evolutivo
export function updateEvolutiveColorConfigData(surveyId, questionId, newData, colorPickerColors, newColor, apiHasNoConfigs = false, dispatch) {
  // calcula nova ordem das cores
  const newColorsArray = sortColorPickerColors(colorPickerColors, newColor, evolutiveChart);
  dispatch({ type: withPending(UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA) });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, evolutiveChart)
    .then((data) => dispatch({ type: withFulFilled(UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }}))
    .catch((error) => dispatch({ type: withRejected(UPDATE_EVOLUTIVE_COLOR_CONFIG_DATA), payload: error }));
}

// action: modificar tamanho das fontes do gráfico evolutivo
export function updateEvolutiveFontSizeConfigData(surveyId, questionId, newFontsSizes, newData, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA), payload: newFontsSizes });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, evolutiveChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA), payload: { data, newFontsSizes }});
    })
    .catch((error) => dispatch({ type: withRejected(UPDATE_EVOLUTIVE_FONTSIZE_CONFIG_DATA), payload: error }));
}

// action: recupera os dados de configurações do gráfico evolutivo de cruzamentos de uma pesquisa e questão
export function fetchEvolutiveCrossChartData(surveyId, questionId, themeColorArray, dispatch) {
  dispatch({ type: withPending(FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA), payload: { themeColorArray }});

  configurationService.fetchConfigData(surveyId, questionId, evolutiveCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA), payload: { data, themeColorArray }});
    })
    .catch((error) => dispatch({ type: withRejected(FETCH_EVOLUTIVE_CROSS_CHART_CONFIG_DATA), payload: { error, themeColorArray }}));
}

// action: atualizar as configurações de cores do gráfico evolutivo de cruzamentos
export function updateEvolutiveCrossColorConfigData(surveyId, questionId, newData, colorPickerColors, newColor, apiHasNoConfigs = false, dispatch) {
  // calcula nova ordem das cores
  const newColorsArray = sortColorPickerColors(colorPickerColors, newColor, evolutiveCrossChart);
  dispatch({ type: withPending(UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA) });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, evolutiveCrossChart)
    .then((data) => dispatch({ type: withFulFilled(UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA), payload: { data, newData, newColor, newColorsArray }}))
    .catch((error) => dispatch({ type: withRejected(UPDATE_EVOLUTIVE_CROSS_COLOR_CONFIG_DATA), payload: error }));
}

// action: modificar tamanho das fontes do gráfico evolutivo de cruzamentos
export function updateEvolutiveCrossFontSizeConfigData(surveyId, questionId, newFontsSizes, newData, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA), payload: newFontsSizes });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, questionId, newData, evolutiveCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA), payload: { data, newFontsSizes }});
    })
    .catch((error) => dispatch({ type: withRejected(UPDATE_EVOLUTIVE_CROSS_FONTSIZE_CONFIG_DATA), payload: error }));
}

// Atualiza as configurações de tema do gráfico evolutivo de cruzamentos
export function updateEvolutiveCrossChartColorScheme(surveyId, questionId, newData, selectedOption, apiHasNoConfigs, dispatch) {
  dispatch({ type: withPending(UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME), payload: {}});
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  const { chartsColors } = newData;

  request(surveyId, questionId, newData, evolutiveCrossChart)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME), payload: { data, newChartsColors: chartsColors, newColorScheme: selectedOption }});
    }).catch((error) => {
      dispatch({ type: withRejected(UPDATE_EVOLUTIVE_CROSS_CHART_COLOR_SCHEME), payload: error });
    });
}

// action: recupera o resultado do simulação de uma pesquisa
// data = {perguntas_correlacionadas: [{id: enunciado, alternativas: {id, enunciado, percentual}}]}
export function calculateSimulationChartData(customerId, surveyId, questionId, data, dispatch) {
  const service = new StatsService();
  const dataPromise = service.resimulation(customerId, surveyId, questionId, data);
  dispatch({ type: CALCULATE_SIMULATION_CHART_DATA, payload: dataPromise });
}

// workaround to resolve error message
// action: limpa o valor do erro depois de exibido
export function resetSimulationChartDataError(dispatch) {
  dispatch({ type: RESET_ERROR_SIMULATION_CHART_DATA, payload: null });
}

// action: recupera os dados de configuração de cor do gráfico de correlação. A correlação
// possui dois modos (auto / manual) que devem ser distinguidos no chartType enviado para a API,
// pois o "analyzeId" pode ter origens distintas (questionId em auto vs configId em manual) e
// não queremos colidir as chaves.
export function fetchCorrelationChartColorConfigData(surveyId, analyzeId, isAuto, dispatch) {
  const chartType = resolveCorrelationChartType(isAuto);
  dispatch({ type: withPending(FETCH_CORRELATION_CHART_CONFIG_DATA) });

  configurationService.fetchConfigData(surveyId, analyzeId, chartType)
    .then((data) => {
      dispatch({ type: withFulFilled(FETCH_CORRELATION_CHART_CONFIG_DATA), payload: { data }});
    })
    .catch((error) => dispatch({ type: withRejected(FETCH_CORRELATION_CHART_CONFIG_DATA), payload: { error }}));
}

// action: atualizar as configurações de cores do gráfico de correlação
export function updateCorrelationColorConfigData(
  surveyId,
  analyzeId,
  isAuto,
  newData,
  colorPickerColors,
  newColor,
  apiHasNoConfigs = false,
  dispatch,
  successCallback,
) {
  const chartType = resolveCorrelationChartType(isAuto);
  // calcula nova ordem das cores (memorizadas no colorpicker). A chave do histórico é
  // unificada ("correlationChart") para que o usuário veja as mesmas cores recentes
  // independentemente do modo (auto/manual)
  const newColorsArray = sortColorPickerColors(colorPickerColors, newColor, 'correlationChart');
  dispatch({ type: withPending(UPDATE_CORRELATION_COLOR_CONFIG_DATA) });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, analyzeId, newData, chartType)
    .then((data) => {
      if (typeof successCallback === 'function') {
        successCallback();
      }
      dispatch({
        type: withFulFilled(UPDATE_CORRELATION_COLOR_CONFIG_DATA),
        payload: { data, newData, newColor, newColorsArray },
      });
    })
    .catch((error) => dispatch({ type: withRejected(UPDATE_CORRELATION_COLOR_CONFIG_DATA), payload: error }));
}

// action: atualizar o tamanho de fonte do gráfico de correlação. Persiste o payload
// completo (incluindo `fontsSizes`) na mesma config indexada por `analyzeId` + `isAuto`.
export function updateCorrelationFontSizeConfigData(
  surveyId,
  analyzeId,
  isAuto,
  newFontsSizes,
  newData,
  apiHasNoConfigs,
  dispatch,
) {
  const chartType = resolveCorrelationChartType(isAuto);
  dispatch({ type: withPending(UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA), payload: newFontsSizes });

  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  request(surveyId, analyzeId, newData, chartType)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA), payload: { data, newFontsSizes }});
    })
    .catch((error) => dispatch({ type: withRejected(UPDATE_CORRELATION_FONTSIZE_CONFIG_DATA), payload: error }));
}

// action: atualizar o esquema de cores do gráfico de correlação (padrão/neutro). Persiste o
// payload com `colorSchemeValue` e o `chartsColors` resultante recalculado pelo ThemeManager.
export function updateCorrelationChartColorScheme(
  surveyId,
  analyzeId,
  isAuto,
  newData,
  selectedOption,
  apiHasNoConfigs,
  dispatch,
) {
  const chartType = resolveCorrelationChartType(isAuto);
  dispatch({ type: withPending(UPDATE_CORRELATION_CHART_COLOR_SCHEME), payload: {}});
  const request = configurationService.getRequestMethod(apiHasNoConfigs);

  const { chartsColors } = newData;

  request(surveyId, analyzeId, newData, chartType)
    .then((data) => {
      dispatch({ type: withFulFilled(UPDATE_CORRELATION_CHART_COLOR_SCHEME), payload: { data, newChartsColors: chartsColors, newColorScheme: selectedOption }});
    })
    .catch((error) => {
      dispatch({ type: withRejected(UPDATE_CORRELATION_CHART_COLOR_SCHEME), payload: error });
    });
}
